import { render, staticRenderFns } from "./payrollList.vue?vue&type=template&id=2f2765ca&scoped=true"
import script from "./payrollList.vue?vue&type=script&lang=js"
export * from "./payrollList.vue?vue&type=script&lang=js"
import style0 from "./payrollList.vue?vue&type=style&index=0&id=2f2765ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2765ca",
  null
  
)

export default component.exports